import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { GridComponent } from "../../core/shared/grid/grid.component";
import { Router } from "@angular/router";
import { DictionaryComponent } from "../dictionary/dictionary.component";
import { Subscription } from "rxjs/Subscription";
import { MessageBoxComponent } from "../../core/shared/message-box.component";
import { ShellSideNavService } from "../../shell/shell-sidenav.service";
import { TranslatorService } from "../../core/translator/translator.service";
import { PermissionsService } from "../../core/services/permissions/permissions.service";
import { Permissions } from "../../core/services/permissions/permissions.model";
import { GridParamsRestorable } from "../../core/services/grid-params-restoring/grid-params-restoring.model";
import { SortedColumn } from "../../core/shared/grid/grid.model";
@Component({
  selector: "dictionaries-grid",
  templateUrl: "./dictionaries.component.html",
  styles: []
})
export class DictionariesComponent implements OnInit, GridParamsRestorable {
  public initialFilters: any;
  public initialPageNumber: number;
  public initialPageSize: number;
  public initialSortedColumn: SortedColumn;
  public editedItemId: any;
  public previousMainFilters: any;
  public detailsPath: string;
  public id: number;
  public path: string;
  public titlePath: string;
  public showSuccessMessage: boolean;
  public viewEnable = true;

  private toggleEnable = true;
  private successMessage: string;
  private sub: any;
  private messageBoxSubscription: Subscription;
  private isEditable: boolean;
  private isRemovable: boolean;
  private isAdd: boolean;
  private isDeleted: boolean;

  @ViewChild(DictionaryComponent)
  public dictionaryComponent: DictionaryComponent;
  @ViewChild(GridComponent) grid: GridComponent;
  @ViewChild(MessageBoxComponent) messageBox: MessageBoxComponent;

  constructor(
    private route: Router,
    private translateService: TranslatorService,
    private shellSideNavService: ShellSideNavService,
    private permissionService: PermissionsService
  ) { }

  ngOnInit() {
    this.setPermissions("UniversalDictionary");

    var routeSplit = this.route.url.split("/");

    this.setTitleAndType(routeSplit[2]);
  }

  private permissions: Permissions;
  private canRowBeShown: boolean;
  private canRowBeEdited: boolean;
  private canRowBeDeleted: boolean;
  private canRowBeAdded: boolean;

  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
    this.isEditable = this.permissions.canEdit || this.permissions.canShow;

    this.canRowBeShown = this.permissions.canShow;
    this.canRowBeAdded = this.permissions.canAdd;
    this.canRowBeEdited = this.permissions.canEdit;
    this.canRowBeDeleted = this.permissions.canDelete;
  }

  public addDictionary() {
    this.dictionaryComponent.openForAdding();
  }

  public onSuccessOperation(isActivationMode) {
    this.grid.refreshData();

    if (this.isDeleted) {
      this.showMesage("DICTIONARIES_deleteDictionaryElementMessage");
    } else if (!isActivationMode && !this.isEditable) {
      this.showMesage("DICTIONARIES_addNewDictionaryElementMessage");
    } else {
      this.showMesage("DICTIONARIES_editDictionaryElementMessage");
    }

    this.isEditable = false;
    this.isDeleted = false;
  }

  public onMessageBoxClose() {
    if (this.messageBoxSubscription) {
      this.messageBoxSubscription.unsubscribe();
    }
  }

  private setTitleAndType(dictType: string) {
    switch (dictType) {
      case "systemdefinitions":
        {
          this.dictionaryComponent.title = "Definicja systemu";
          this.dictionaryComponent.dictionaryType = 1;
          this.titlePath = "Słowniki / Definicja systemu";
          this.path = "api/dictionaries/grid/1";
        }
        break;
      case "projecttypes":
        {
          this.dictionaryComponent.title = "Typy projektów";
          this.dictionaryComponent.dictionaryType = 2;
          this.titlePath = "Słowniki / Typy projektów";
          this.path = "api/dictionaries/grid/2";
        }
        break;
      case "issuetypes":
        {
          this.dictionaryComponent.title = "Typy zgłoszeń";
          this.dictionaryComponent.dictionaryType = 3;
          this.titlePath = "Słowniki / Typy zgłoszeń";
          this.path = "api/dictionaries/grid/3";
        }
        break;
      case "worklogtypes":
        {
          this.dictionaryComponent.title = "Typy rejestratora czasu";
          this.dictionaryComponent.dictionaryType = 5;
          this.titlePath = "Słowniki / Typy rejestratora czasu";
          this.path = "api/dictionaries/grid/5";
        }
        break;
      case "areapaths":
        {
          this.dictionaryComponent.title = "Obszar klasyfikacji";
          this.dictionaryComponent.dictionaryType = 6;
          this.titlePath = "Słowniki / Obszar klasyfikacji";
          this.path = "api/dictionaries/grid/6";
        }
        break;
      case "schedulertypes":
        {
          this.dictionaryComponent.title = "Typy planu pracy";
          this.dictionaryComponent.dictionaryType = 7;
          this.titlePath = "Słowniki / Typy planu pracy";
          this.path = "api/dictionaries/grid/7";
        }
        break;
      case "funcionalitytypes":
        {
          this.dictionaryComponent.title = "Typy funkcjonalności";
          this.dictionaryComponent.dictionaryType = 8;
          this.titlePath = "Słowniki / Typy funkcjonalności";
          this.path = "api/dictionaries/grid/8";
        }
        break;
      case "vstsprojects":
        {
          this.dictionaryComponent.title = "Projekty VSTS";
          this.dictionaryComponent.dictionaryType = 9;
          this.titlePath = "Słowniki / Projekty VSTS";
          this.path = "api/dictionaries/grid/9";
        }
        break;
      case "erpvstsprojects":
        {
          this.dictionaryComponent.title = "Projekty ERP VSTS";
          this.dictionaryComponent.dictionaryType = 10;
          this.titlePath = "Słowniki / Projekty ERP VSTS";
          this.path = "api/dictionaries/grid/10";
        }
        break;
      case "absencetypes":
        {
          this.dictionaryComponent.title = "Typy nieobecności";
          this.dictionaryComponent.dictionaryType = 11;
          this.titlePath = "Słowniki / TYPY NIEOBECNOŚCI";
          this.path = "api/dictionaries/grid/11";
        }
        break;
      default: {
        this.dictionaryComponent.title = "Inne";
        this.dictionaryComponent.dictionaryType = 0;
        this.titlePath = "Słowniki / Inne";
      }
    }
  }

  public headers = [
    { displayName: "Nazwa", propertyName: "value", propertyType: "string" },
    { displayName: "Opis", propertyName: "description", propertyType: "string" }
  ];

  public actionButtons = [];

  private onActivate(actionData: any) { }

  private onRowEdit(row: any) {
    this.dictionaryComponent.openForEdit(row.id);
  }

  private onRowDelete(row: any) {
    this.isDeleted = true;
    sweetAlert("Czy usunąć element słownika?", {
      buttons: {
        yes: {
          text: "Tak",
          value: "yes"
        },
        no: {
          text: "Nie",
          value: "no"
        }
      }
    }).then(value => {
      switch (value) {
        case "yes":
          this.dictionaryComponent.deleteDictionary(row.id);
          break;
      }
    });
  }

  showMesage(translateMessage: string) {
    this.translateService.translate.get(translateMessage).subscribe(value => {
      this.successMessage = value;
      this.showSuccessMessage = true;
      setTimeout(() => (this.showSuccessMessage = false), 3000);
    });
  }
}
